import { gql } from '@apollo/client';

export const ENABLE_EMAIL_NOTIFICATION_MUTATION = gql`
  mutation EnableEmailNotificationMutation($agentID: ID!, $input: EmailNotificationInput!) {
    enableEmailNotification(agentID: $agentID, input: $input) {
      ID
      frequency
      name
    }
  }
`;
